<template>
    <div class="importar_matriz">
        <!-- FORMULARIO -->
        <form v-on:submit.prevent="alternarCentroTrabajo()">
            <!-- DATOS DEL CENTRO DE TRABAJO -->
            <div class="bg-light m-4 p-3 rounded border-orange">
                <h3 style="text-align: center !important; color: #878787; font-size: 20px; font-weight: bold;">
                    DATOS DEL CENTRO DE TRABAJO
                </h3>
                <hr />
                <div class="col-md-12">
                    <div class="row justify-content-center">
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Cliente: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Seleccione uno de los clientes con el que vinculará la matriz de peligros"></i></span></label>
                            <v-select class="form-control form-control-sm boton_texto mt-5" v-model="cliente.nombre"
                                @input="obtenerCliente()" :options="clientes" required />
                        </div>
                        <div class="col-md-4">
                            <label class="color_letra mt-3">Grupo de Exposición Similar: *<span
                                    class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="El grupo de exposición similar es la agrupación de los clientes de acuerdo a su actividad económica principal"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.sector" type="text"
                                required disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Nombre del Centro de Trabajo: *<span
                                    class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="Indique el nombre del Centro de Trabajo al que va a realizar la matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.centroTrabajo"
                                type="text" placeholder="Nombre del Centro de Trabajo" required />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Expuestos: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Indique a continuación el número de trabajadores objeto de la presente matriz de peligros, incluir trabajadores que están en descanso y/u otros turnos"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.numeroExpuestos"
                                type="number" min="0" placeholder="N° de Expuestos" required />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Regional: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Seleccione a continuación la regional a la que pertenece el Centro de Trabajo"></i></span></label>
                            <select class="form-control form-control-sm boton_texto"
                                v-model="cliente.ubicacion.regional" @change="obtenerDepartamentos()" id="regional"
                                required>
                                <option value="" selected disabled>
                                    Seleccione la regional
                                </option>
                                <option v-for="(regional, index) of regionales" :key="index">
                                    {{ regional }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Departamento: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Seleccione a continuación el departamento al que pertenece el Centro de Trabajo"></i></span></label>
                            <select class="form-control form-control-sm boton_texto"
                                v-model="cliente.ubicacion.departamento" @change="obtenerMunicipios()" id="departamento"
                                required>
                                <option value="" selected disabled>
                                    Seleccione el departamento
                                </option>
                                <option v-for="(departamento, index) of departamentos" :key="index">
                                    {{ departamento }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Ciudad/Municipio: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Seleccione a continuación la ciudad o muncipio al que pertencece el Centro de Trabajo"></i></span></label>
                            <select class="form-control form-control-sm boton_texto" id="ciudad"
                                v-model="cliente.ubicacion.municipio" required>
                                <option value="" selected disabled>
                                    Seleccione la ciudad
                                </option>
                                <option v-for="(municipio, index) of municipios" :key="index">
                                    {{ municipio }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Dirección:
                                <span class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="Relaciona a continuación la dirección donde se ubica el Centro de Trabajo"></i></span></label>
                            <input class="form-control form-control-sm boton_texto"
                                v-model="cliente.ubicacion.direccion" type="text" min="1"
                                placeholder="Dirección del centro de trabajo" />
                        </div>
                        <div class="col-md-4 col-12 form-group">
                            <label class="color_letra mt-3"><b>Ubicación GPS de la Residencia Actual</b></label>
                            <br />
                            <div class="row">
                                <div class="col-sm-2">
                                    <button class="btn gps btn-sm mb-1" type="button" @click="obtenerCoordenadas()">
                                        Obtener
                                    </button>
                                </div>
                                <div class="col-sm-10">
                                    <input
                                        class="form-control form-control-sm form-control form-control-sm-sm boton_texto"
                                        v-model="cliente.ubicacion.coordenadas" type="text" readonly required />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Contacto del centro de trabajo: *<span
                                    class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="Relaciona a continuación la persona contacto o representante de la empresa en el Centro de Trabajo con quien se coordinó la actividad de la matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.contacto.nombre"
                                type="text" placeholder="Nombre de la persona" required readonly />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Cargo: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Relacione a continuación el cargo de la persona contacto con quien se coordinó la actividad de la matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.contacto.cargo"
                                type="text" placeholder="Cargo de la persona" onchange="value=toTitleCase(this.value)"
                                onkeyup="value=toTitleCase(this.value)" required readonly />
                        </div>
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Correo Electrónico: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Relacione a continuación el correo del contacto del centro de trabajo con quien se coordinó la actividad de matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.contacto.correo"
                                type="email" placeholder="Correo electrónico" required readonly />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Celular/Teléfono: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip"
                                        data-placement="right" data-html="true"
                                        title="Relacione a continuación un numero telefónico del contacto del centro de trabajo con quien se coordino la actividad de matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="cliente.contacto.telefono"
                                type="number" min="1" placeholder="Celular o teléfono" required readonly />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Fecha Matriz:
                                <a class="btn btn-sm btn-form font-weight-bold btn-block" data-toggle="modal"
                                    data-target="#controlCambios" type="button">
                                    <i class="fas fa-calendar-alt"></i>
                                </a>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- SELECCIONAR ARCHIVO Y MATRIZ EXTRAIDA -->
            <div class="bg-light m-4 p-3 rounded border-orange">
                <div class="col-md-12 text-left">
                    <input type="file" id="seleccionador"
                        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        @change="seleccionarArchivo" required />
                </div>
                <div class="col-md-12 mt-3">
                    <p class="text-left">
                        <b>Cantidad de Registros Cargados: </b> {{ registros.length }}<br />
                        <b class="text-danger">
                            Cantidad de Registros Sin Clasificación:
                        </b>
                        {{ registrosSinClasificacion }}<br />
                        <b class="text-danger">
                            Cantidad de Registros Sin Subclasificación:
                        </b>
                        {{ registrosSinSubclasificacion }}
                    </p>
                    <vue-good-table class="mb-4" :columns="columnas" :rows="registros" max-height="620px"
                        :pagination-options="{
                            enabled: true,
                            mode: 'records',
                            jumpFirstOrLast: true,
                            perPage: 10,
                            setCurrentPage: 1,
                            rowsPerPageLabel: 'Registros',
                            firstLabel: 'Primera',
                            lastLabel: 'Última',
                            nextLabel: 'Sig.',
                            prevLabel: 'Ant.',
                            ofLabel: 'de',
                            allLabel: 'Todos',
                            dropdownAllowAll: false,
                        }">
                        <div slot="emptystate" class="text-center">
                            No se encontraron registros
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <div v-if="props.column.field == 'em_actividad'">
                                <p style="white-space: pre-line;" class="mb-0">
                                    {{ props.row.em_actividad ? props.row.em_actividad : "-" }}
                                </p>
                            </div>
                            <div v-else-if="props.column.field == 'em_tarea'">
                                <div v-if="!Array.isArray(props.row.em_tarea)">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ props.row.em_tarea ? props.row.em_tarea : "-" }}
                                    </p>
                                </div>
                                <div v-else v-for="(tarea, index) of props.row.em_tarea" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ tarea ? tarea : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_descripcion'">
                                <p style="white-space: pre-line;" class="mb-0">
                                    {{ props.row.em_descripcion ? props.row.em_descripcion : "-" }}
                                </p>
                            </div>
                            <div v-else-if="props.column.field == 'em_clasificacion'">
                                <select v-model="props.row.em_clasificacion" class="form-control"
                                    :title="props.row.em_clasificacion" @change="seleccionarClasificacion(props.row)">
                                    <option value="" disabled>
                                        Selecciona una clasificación
                                    </option>
                                    <option v-for="(item, index) of peligros.clasificacion" :key="index">
                                        {{ item.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div v-else-if="props.column.field == 'em_tipo'">
                                <select v-model="props.row.em_tipo" class="form-control" :title="props.row.em_tipo"
                                    @change="seleccionarSubclasificacion(props.row)">
                                    <option value="" disabled>
                                        Selecciona una subclasificación
                                    </option>
                                    <option v-for="(item, index) of obtenerSubclasificaciones(props.row.em_id_peligro)"
                                        :key="index">
                                        {{ item.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div v-else-if="props.column.field == 'em_efecto_posible'">
                                <div v-for="(efecto, index) in props.row.em_efecto_posible" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ efecto ? efecto : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_c_fuente'">
                                <div v-for="(fuente, index) in props.row.em_c_fuente" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ fuente ? fuente : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_c_medio'">
                                <div v-for="(medio, index) in props.row.em_c_medio" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ medio ? medio : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_c_individuo'">
                                <div v-for="(individuo, index) in props.row.em_c_individuo" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ individuo ? individuo : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_aceptabilidad'" class="rounded p-2" :class="{
                                'bg_danger': props.row.em_aceptabilidad === 'No Aceptable',
                                'bg_warning': props.row.em_aceptabilidad === 'Aceptable con Control Específico',
                                'bg_success': props.row.em_aceptabilidad === 'Aceptable' || props.row.em_aceptabilidad === 'Mejorable'
                            }">
                                <b>{{ props.row.em_aceptabilidad }}</b>
                            </div>
                            <div v-else-if="props.column.field == 'em_eliminacion'">
                                <div v-if="!Array.isArray(props.row.em_eliminacion)">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ props.row.em_eliminacion ? props.row.em_eliminacion : "-" }}
                                    </p>
                                </div>
                                <div v-else v-for="(eliminacion, index) of props.row.em_eliminacion" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ eliminacion ? eliminacion : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_sustitucion'">
                                <div v-if="!Array.isArray(props.row.em_sustitucion)">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ props.row.em_sustitucion ? props.row.em_sustitucion : "-" }}
                                    </p>
                                </div>
                                <div v-else v-for="(sustitucion, index) of props.row.em_sustitucion" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ sustitucion ? sustitucion : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_controles_ing'">
                                <div v-if="!Array.isArray(props.row.em_controles_ing)">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ props.row.em_controles_ing ? props.row.em_controles_ing : "-" }}
                                    </p>
                                </div>
                                <div v-else v-for="(control, index) of props.row.em_controles_ing" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ control ? control : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_controles'">
                                <div v-if="!Array.isArray(props.row.em_controles)">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ props.row.em_controles ? props.row.em_controles : "-" }}
                                    </p>
                                </div>
                                <div v-else v-for="(control, index) of props.row.em_controles" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ control ? control : "-" }}
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="props.column.field == 'em_equipos'">
                                <div v-if="!Array.isArray(props.row.em_equipos)">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ props.row.em_equipos ? props.row.em_equipos : "-" }}
                                    </p>
                                </div>
                                <div v-else v-for="(equipo, index) of props.row.em_equipos" :key="index">
                                    <p style="white-space: pre-line;" class="mb-0">
                                        {{ equipo ? equipo : "-" }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
                <div class="col-md-12 mt-3">
                    <router-link to="/lista_clientes">
                        <button class="btn btn-sm btn-secondary rounded-pill font-weight-bold" type="button">
                            Cancelar
                        </button>
                    </router-link>
                    <button class="btn btn-sm btn-form font-weight-bold ml-2" type="submit">
                        {{ id ? "Editar" : "Importar" }} Matriz
                    </button>
                </div>
            </div>
        </form>
        <!-- MODAL CONTROL DE CAMBIOS -->
        <div class="modal fade" id="controlCambios" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-light">
                    <div class="modal-header">
                        <h5 class="modal-title dato" id="exampleModalLabel">
                            Control de Cambios
                        </h5>
                        <button class="close" data-dismiss="modal" type="button" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label class="color_letra mb-4">Tipo de Cambio: * </label>
                                <select class="form-control form-control-sm boton_texto mt-4"
                                    v-model="controlCambioMatriz.controlCambios.tipoCambio">
                                    <option disabled selected>Seleccione...</option>
                                    <option value="Elaboración">Elaboración</option>
                                    <option value="Actualización">Actualización</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="color_letra mb-4">Fecha: * </label>
                                <input class="form-control form-control-sm boton_texto" v-model="fechaCambio"
                                    type="date" />
                            </div>
                            <div class="col-md-6">
                                <label class="color_letra">Observación:</label>
                                <textarea class="form-control form-control-sm boton_texto" v-model="controlCambioMatriz.controlCambios.observacionCambio
                                    " placeholder="Observación." autocomplete="on"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button class="btn btn-sm btn-form font-weight-bold" data-dismiss="modal" type="button">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { firebase, db } from "@/firebase";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import moment from "moment";
export default {
    name: "importar_matriz",

    data() {
        return {
            id: this.$route.params.id,
            cliente: {
                id: "",
                nombre: "",
                sector: "",
                centroTrabajo: "",
                numeroExpuestos: "",
                ubicacion: {
                    regional: "",
                    pais: "Colombia",
                    departamento: "",
                    municipio: "",
                    direccion: "",
                    coordenadas: "",
                },
                contacto: {
                    nombre: "Ángela Johana Gaitán López",
                    cargo: "Gerente H&S",
                    correo: "angela.gaitan@co.g4s.com",
                    telefono: 3212543320
                }
            },
            controlCambioMatriz: {
                controlCambios: {
                    idControlCambio: "",
                    tipoCambio: this.$route.params.id ? "Actualización" : "Elaboración",
                    fechaCambio: "",
                    observacionCambio: "",
                    correoUsuario: this.$store.state.email_session,
                },
                registro: {
                    creacion: firebase.firestore.FieldValue.serverTimestamp(),
                },
            },
            fechaCambio: "",
            clientes: [],
            regionales: [],
            departamentos: [],
            municipios: [],
            peligros: {
                clasificacion: [],
                subclasificacion: []
            },
            registros: [],
            columnas: [
                {
                    label: "PROCESO, PUESTO O SECTOR ECONÓMICO",
                    field: "em_proceso",
                    width: "200px",
                    thClass: "text-center align-middle bg_blue",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "ZONA / LUGAR",
                    field: "em_zona",
                    width: "200px",
                    thClass: "text-center align-middle bg_blue",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "ACTIVIDADES",
                    field: "em_actividad",
                    width: "300px",
                    thClass: "text-center align-middle bg_blue",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "TAREAS",
                    field: "em_tarea",
                    width: "300px",
                    thClass: "text-center align-middle bg_blue",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "TAREA RUTINARIA",
                    field: "em_rutinario",
                    width: "200px",
                    thClass: "text-center align-middle bg_blue",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                        filterDropdownItems: ["Si", "No"]
                    },
                },
                {
                    label: "DESCRIPCIÓN DEL PELIGRO",
                    field: "em_descripcion",
                    width: "300px",
                    thClass: "text-center align-middle bg_gray",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "CLASIFICACIÓN DEL PELIGRO",
                    field: "em_clasificacion",
                    width: "300px",
                    thClass: "text-center align-middle bg_gray",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "SUBCLASIFICACIÓN DEL PELIGRO",
                    field: "em_tipo",
                    width: "300px",
                    thClass: "text-center align-middle bg_gray",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "EFECTOS POSIBLES",
                    field: "em_efecto_posible",
                    width: "300px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "FUENTE",
                    field: "em_c_fuente",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "MEDIO",
                    field: "em_c_medio",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "INDIVIDUO",
                    field: "em_c_individuo",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "NIVEL DE DEFICIENCIA (ND)",
                    field: "em_nivel_eficiencia",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "NIVEL DE EXPOSICIÓN (NE)",
                    field: "em_nivel_exposicion",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "NIVEL DE PROBABILIDAD (ND*NE)",
                    field: "em_nivel_probabilidad",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                    },
                },
                {
                    label: "INTERPRETACIÓN DEL NIVEL DE PROBABILIDAD",
                    field: "em_interpretacion",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                        filterDropdownItems: ["Bajo", "Medio", "Alto", "Muy Alto"]
                    },
                },
                {
                    label: "NIVEL DE CONSECUENCIA",
                    field: "em_nivel_consecuencia",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "NIVEL DE RIESGO E INTERVENCIÓN (NR)",
                    field: "em_nivel_riesgo",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "INTERPRETACIÓN DEL NIVEL DE RIESGO (NR)",
                    field: "em_interpretacion_nr",
                    width: "180px",
                    thClass: "text-center align-middle bg_blue_light",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "ACEPTABILIDAD DEL RIESGO",
                    field: "em_aceptabilidad",
                    width: "200px",
                    thClass: "text-center align-middle bg_purple",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR",
                        filterDropdownItems: ["Aceptable", "Aceptable con Control Específico", "Mejorable", "No Aceptable"]
                    },
                },
                {
                    label: "Nº EXPUESTOS",
                    field: "em_num_expuestos",
                    width: "180px",
                    thClass: "text-center align-middle bg_yellow",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "PEOR CONSECUENCIA",
                    field: "em_peor_consecuencia",
                    width: "200px",
                    thClass: "text-center align-middle bg_yellow",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "ELIMINACIÓN",
                    field: "em_eliminacion",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "SUSTITUCIÓN",
                    field: "em_sustitucion",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "CONTROLES DE INGENIERÍA",
                    field: "em_controles_ing",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "CONTROLES ADMINISTRATIVOS, SEÑALIZACIÓN, ADVERTENCIA",
                    field: "em_controles",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                },
                {
                    label: "EQUIPOS / EPP",
                    field: "em_equipos",
                    width: "300px",
                    thClass: "text-center align-middle bg_orange",
                    tdClass: "text-center align-middle",
                    filterOptions: {
                        enabled: true,
                        placeholder: "FILTRAR"
                    },
                }
            ],
            matriz: []
        };
    },

    watch: {
        $route(to) {
            this.id = to.params.id;
        },
    },

    computed: {
        registrosSinClasificacion() {
            return this.registros.length > 0 ? this.registros.filter(item => item.em_clasificacion === "Sin Clasificación").length : 0;
        },

        registrosSinSubclasificacion() {
            return this.registros.length > 0 ? this.registros.filter(item => item.em_tipo === "Sin Subclasificación").length : 0;
        },
    },

    async created() {
        $(() => {
            $('[data-toggle="tooltip"]').tooltip();
        });
        if (!this.$store.state.email) {
            this.$router.replace("/");
            return;
        }
        this.$isLoading(true);
        if (this.id) {
            await this.obtenerCentroTrabajo();
            await this.obtenerMatriz();
        }
        await this.obtenerClientes();
        await this.obtenerPeligros();
        await this.obtenerRegionales();
        this.$isLoading(false);
    },

    methods: {
        async obtenerCentroTrabajo() {
            await db.collection("cliente_empresa").doc(this.id).get().then(async (doc) => {
                if (doc.exists) {
                    if (doc.data().em_id_cliente_principal) {
                        await this.obtenerEmpresaPrincipal(doc.data().em_id_cliente_principal);
                    }
                    this.cliente.centroTrabajo = doc.data().em_trabajo;
                    this.cliente.numeroExpuestos = parseInt(doc.data().em_num_trabajadores, 10);
                    this.cliente.ubicacion.departamento = doc.data().em_departamento;
                    this.cliente.ubicacion.municipio = doc.data().em_ciudad;
                    this.cliente.ubicacion.direccion = doc.data().em_direccion;
                    this.cliente.ubicacion.coordenadas = doc.data().em_gps;
                    if (doc.data().em_regional) {
                        this.cliente.ubicacion.regional = doc.data().em_regional;
                        await this.obtenerDepartamentos();
                        await this.obtenerMunicipios();
                    } else {
                        await this.obtenerRegional(doc.data().em_departamento);
                    }
                }
            });
        },

        async obtenerMatriz() {
            // HELPERS
            const obtenerRegistrosPorColeccion = async (coleccion) => {
                let registros = [];
                await db.collection(coleccion).where("em_id_cliente", "==", this.id).get().then((querySnapshot) => {
                    if (querySnapshot.docs.length > 0) {
                        registros = querySnapshot.docs.map(doc => {
                            return {
                                coleccion,
                                id: doc.id
                            }
                        })
                    }
                });
                return registros;
            };

            // LLAMADOS
            const procesos = await obtenerRegistrosPorColeccion("proceso");
            const zonas = await obtenerRegistrosPorColeccion("zona");
            const actividades = await obtenerRegistrosPorColeccion("actividades");
            const tareas = await obtenerRegistrosPorColeccion("tareas");
            const peligros = await obtenerRegistrosPorColeccion("matriz_riesgo");

            // UNIÓN DE ARREGLOS
            this.matriz = [...procesos, ...zonas, ...actividades, ...tareas, ...peligros];
        },

        async obtenerRegional(departamento) {
            await db.collection("nuevo_regional")
                .where("r_departamento", "==", departamento)
                .get()
                .then(async (querySnapshot) => {
                    if (querySnapshot.docs.length > 0) {
                        this.cliente.ubicacion.regional = querySnapshot.docs[0].data().r_nueva_region;
                        await this.obtenerDepartamentos();
                        await this.obtenerMunicipios();
                    }
                });
        },

        async obtenerEmpresaPrincipal(id) {
            await db.collection("cliente_principal").doc(id).get().then(async (doc) => {
                this.cliente.id = doc.id;
                this.cliente.nombre = doc.data().cl_cliente;
                this.cliente.sector = doc.data().cl_sector;
            });
        },

        async obtenerClientes() {
            this.clientes = [];
            await db.collection("cliente_principal").where("cl_estado", "==", "En Servicio").orderBy("cl_cliente").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    this.clientes.push(doc.data().cl_cliente);
                });
            });
            let set = new Set(this.clientes.map(JSON.stringify));
            this.clientes = Array.from(set).map(JSON.parse);
        },

        async obtenerCliente() {
            await db.collection("cliente_principal").where("cl_cliente", "==", this.cliente.nombre).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    this.cliente.id = doc.id;
                    this.cliente.sector = doc.data().cl_sector;
                });
            })
        },

        async obtenerRegionales() {
            if (this.$store.state.global_privilegio_regionales_todas) {
                await db.collection("nuevo_regional").where("r_registrado_por", "==", this.$store.state.email).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        this.regionales.push(doc.data().r_nueva_region);
                    });
                });
                let set = new Set(this.regionales.map(JSON.stringify));
                this.regionales = Array.from(set).map(JSON.parse);
            } else {
                this.$store.state.global_privilegio_regional.forEach((x) => {
                    this.regionales.push(x.nombre_regional);
                });
                let set = new Set(this.regionales.map(JSON.stringify));
                this.regionales = Array.from(set).map(JSON.parse);
            }
        },

        async obtenerDepartamentos() {
            this.departamentos = [];
            this.municipios = [];
            if (this.$store.state.global_privilegio_regionales_todas) {
                await db.collection("nuevo_regional")
                    .where("r_nueva_region", "==", this.cliente.ubicacion.regional)
                    .where("r_registrado_por", "==", this.$store.state.email)
                    .orderBy("r_departamento", "asc")
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            this.departamentos.push(doc.data().r_departamento);
                        });
                    });
                let set = new Set(this.departamentos.map(JSON.stringify));
                this.departamentos = Array.from(set).map(JSON.parse);
            } else {
                this.$store.state.global_privilegio_regional.forEach((x) => {
                    if (x.nombre_regional == this.cliente.ubicacion.regional) {
                        x.departamentos.forEach((y) => {
                            this.departamentos.push(y.nombre_departamento);
                        });
                    }
                });
                let set = new Set(this.departamentos.map(JSON.stringify));
                this.departamentos = Array.from(set).map(JSON.parse);
            }
        },

        async obtenerMunicipios() {
            this.municipios = [];
            if (this.$store.state.global_privilegio_regionales_todas) {
                await db.collection("nuevo_regional")
                    .where("r_nueva_region", "==", this.cliente.ubicacion.regional)
                    .where("r_departamento", "==", this.cliente.ubicacion.departamento)
                    .where("r_registrado_por", "==", this.$store.state.email)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            this.municipios = doc.data().r_municipios;
                        });
                    });
                let set = new Set(this.municipios.map(JSON.stringify));
                this.municipios = Array.from(set).map(JSON.parse);
            } else {
                this.$store.state.global_privilegio_regional.forEach((x) => {
                    if (x.nombre_regional == this.cliente.ubicacion.regional) {
                        x.departamentos.forEach((y) => {
                            if (y.nombre_departamento == this.cliente.ubicacion.departamento) {
                                this.municipios = y.municipios;
                            }
                        });
                    }
                });
                let set = new Set(this.municipios.map(JSON.stringify));
                this.municipios = Array.from(set).map(JSON.parse);
            }
        },

        async obtenerPeligros() {
            this.peligros.clasificacion = [{ id: "", nombre: "Sin Clasificación" }];
            await db.collection("nuevo_peligro").orderBy("p_nuevo_peligro").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    if (doc.data().p_nuevo_peligro) {
                        this.peligros.clasificacion.push({
                            id: doc.id,
                            nombre: doc.data().p_nuevo_peligro
                        });
                    }
                });
            });
            let set = new Set(this.peligros.clasificacion.map(JSON.stringify));
            this.peligros.clasificacion = Array.from(set).map(JSON.parse);
            this.columnas[6].filterOptions.filterDropdownItems = [...this.peligros.clasificacion.map(item => item.nombre)];

            this.peligros.subclasificacion = [{ id: "", nombre: "Sin Subclasificación" }];
            await db.collection("nuevo_subclasificacion").orderBy("p_nuevo_subclasificacion").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    if (doc.data().p_id_peligro && doc.data().p_nuevo_subclasificacion) {
                        this.peligros.subclasificacion.push({
                            id: doc.id,
                            idPeligro: doc.data().p_id_peligro,
                            nombre: doc.data().p_nuevo_subclasificacion
                        });
                    }
                });
            });
            let set2 = new Set(this.peligros.subclasificacion.map(JSON.stringify));
            this.peligros.subclasificacion = Array.from(set2).map(JSON.parse);
            this.columnas[7].filterOptions.filterDropdownItems = [...this.peligros.subclasificacion.map(item => item.nombre)]
        },

        obtenerCoordenadas() {
            this.cliente.ubicacion.coordenadas = "";
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.cliente.ubicacion.coordenadas = position.coords.latitude + ", " + position.coords.longitude;
                    Swal.fire({
                        icon: "success",
                        position: "center",
                        background: "transparent",
                        html: '<h4 style="color: rgb(255, 255, 255)">¡Ubicación obtenida correctamente!</h4>',
                        backdrop: `rgba(0,0,0,0.8)`,
                        showConfirmButton: false,
                        timer: 1500,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                });
            } else {
                console.log("¡El navegador no soporta la geolocalización!");
            }
        },

        seleccionarClasificacion(item) {
            const registro = this.peligros.clasificacion.find(p => p.nombre === item.em_clasificacion);
            this.registros[item.originalIndex].em_id_peligro = registro ? registro.id : "";
            this.registros[item.originalIndex].em_clasificacion = registro ? registro.nombre : "";
            this.registros[item.originalIndex].em_id_subclasificacion = "";
            this.registros[item.originalIndex].em_tipo = "Sin Subclasificación";
        },

        obtenerSubclasificaciones(idPeligro) {
            const filtro = this.peligros.subclasificacion.filter(p => p.idPeligro === idPeligro);
            return filtro.length > 0 ? [{ id: "", idPeligro: idPeligro, nombre: "Sin Subclasificación" }].concat(filtro) : [{ id: "", idPeligro: idPeligro, nombre: "Sin Subclasificación" }];
        },

        seleccionarSubclasificacion(item) {
            const registro = this.peligros.subclasificacion.find(p => p.nombre === item.em_tipo);
            this.registros[item.originalIndex].em_id_subclasificacion = registro ? registro.id : "";
            this.registros[item.originalIndex].em_tipo = registro ? registro.nombre : "";
        },

        seleccionarArchivo(e) {
            const file = e.target.files && e.target.files[0];
            if (!file) return;

            this.registros = [];

            const reader = new FileReader();
            reader.onload = () => {
                this.$isLoading(true);
                const wb = XLSX.read(reader.result, { type: "array", cellDates: true });
                const hojas = wb.SheetNames || [];
                const hojaSeleccionada = hojas[0] || "";
                this.extraerDatosArchivo(wb, hojaSeleccionada);
                setTimeout(() => {
                    this.$isLoading(false);
                }, 1000);
            };
            reader.readAsArrayBuffer(file);
        },

        tieneRegistros(ws, dataStartRow, endRow, cols) {
            const cDesc = cols.peligroDescripcion ?? 5;
            const cClas = cols.peligroClasificacion ?? 6;
            const cEfe = cols.efectosPosibles ?? 7;

            let count = 0;

            for (let r = dataStartRow; r <= endRow; r++) {
                const desc = this.obtenerTextoCelda(ws, r, cDesc);
                const clas = this.obtenerTextoCelda(ws, r, cClas);
                const efe = this.obtenerTextoCelda(ws, r, cEfe);

                if (desc || clas || efe) {
                    count++;
                    return true;
                }
            }

            return false;
        },

        extraerDatosArchivo(workbook, hojaSeleccionada) {
            if (!workbook || !hojaSeleccionada) return;

            const ws = workbook.Sheets[hojaSeleccionada];
            if (!ws || !ws["!ref"]) return;

            const range = XLSX.utils.decode_range(ws["!ref"]);
            const endRow = range.e.r;
            const endCol = range.e.c;

            const headerRow = this.obtenerCabeceraFilaPorCeldas(ws, range);
            const dataStartRow = headerRow + 2;

            const cols = this.detectarColumnaPorEncabezado(ws, headerRow, endCol);
            const tieneRegistros = this.tieneRegistros(ws, dataStartRow, endRow, cols);

            if (!tieneRegistros) {
                this.$isLoading(false);
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "¡Sin registros!",
                    text: "El archivo no contiene registros para procesar.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "Entendido",
                }).then((result) => {
                    if (result.value) {
                        this.registros = [];
                        document.getElementById('seleccionador').value = "";
                    }
                });
                return;
            }

            const out = [];
            for (let r = dataStartRow; r <= endRow; r++) {
                const desc = this.obtenerTextoCelda(ws, r, cols.peligroDescripcion ?? 5);
                const clasif = this.obtenerTextoCelda(ws, r, cols.peligroClasificacion ?? 6);
                const efectos = this.obtenerTextoCelda(ws, r, cols.efectosPosibles ?? 7);

                if (!desc && !clasif && !efectos) continue;

                const proceso = this.rellenarCelda(ws, r, cols.proceso ?? 0, dataStartRow);
                const zonaLugar = this.rellenarCelda(ws, r, cols.zonaLugar ?? 1, dataStartRow);
                const actividades = this.rellenarCelda(ws, r, cols.actividades ?? 2, dataStartRow);
                const tareas = this.rellenarCelda(ws, r, cols.tareas ?? 3, dataStartRow);
                const tareaRutinaria = this.normalizarTareaRutinaria(this.rellenarCelda(ws, r, cols.tareaRutinaria ?? 4, dataStartRow));

                const procesoRef = db.collection("proceso").doc();
                const zonaRef = db.collection("zona").doc();
                const actividadRef = db.collection("actividades").doc();
                const tareaRef = db.collection("tareas").doc();

                const idProceso = procesoRef.id;
                const idZona = zonaRef.id;
                const idActividad = actividadRef.id;
                const idTarea = tareaRef.id;

                const peligro = this.convertirTextoCapital(this.extraerPeligro(clasif));
                const subclasificacion = this.extraerSubClasificacionPeligro(clasif);

                const obtenerClasificacionPeligro = this.obtenerClasificacionPeligro(peligro);
                const obtenerSubClasificacionPeligro = this.obtenerSubClasificacionPeligro(subclasificacion, obtenerClasificacionPeligro ? obtenerClasificacionPeligro.id : "");

                out.push({
                    em_id_proceso: idProceso,
                    em_id_acti: idActividad,
                    em_id_tareas: idTarea,
                    em_id_zona: idZona,
                    em_id_cliente: "",
                    em_id_cliente_iper: "",
                    em_id_efectos_posibles: "",
                    em_id_peligro: obtenerClasificacionPeligro ? obtenerClasificacionPeligro.id : "",
                    em_id_subclasificacion: obtenerSubClasificacionPeligro ? obtenerSubClasificacionPeligro.id : "",
                    em_img_peligro: "",
                    em_img_peligro2: "",
                    em_proceso: proceso,
                    em_zona: zonaLugar,
                    em_actividad: actividades,
                    em_tarea: tareas,
                    em_rutinario: tareaRutinaria,
                    em_clasificacion: obtenerClasificacionPeligro ? obtenerClasificacionPeligro.nombre : "Sin Clasificación",
                    em_tipo: obtenerClasificacionPeligro && obtenerSubClasificacionPeligro ? obtenerSubClasificacionPeligro.nombre : "Sin Subclasificación",
                    em_descripcion: desc,
                    em_efecto_posible: [efectos, this.obtenerTextoCelda(ws, r, cols.peorConsecuencia ?? 20)],
                    em_c_fuente: [this.obtenerTextoCelda(ws, r, cols.controlesFuente ?? 8)],
                    em_c_medio: [this.obtenerTextoCelda(ws, r, cols.controlesMedio ?? 9)],
                    em_c_individuo: [this.obtenerTextoCelda(ws, r, cols.controlesIndividuo ?? 10)],
                    em_nivel_eficiencia: this.obtenerTextoCelda(ws, r, cols.nd ?? 11),
                    em_nivel_exposicion: this.obtenerTextoCelda(ws, r, cols.ne ?? 12),
                    em_nivel_probabilidad: this.obtenerNumeroCelda(ws, r, cols.np ?? 13),
                    em_interpretacion: this.normalizarInterpretacionNP(this.obtenerTextoCelda(ws, r, cols.interpretacionNP ?? 14)),
                    em_nivel_consecuencia: this.obtenerTextoCelda(ws, r, cols.nc ?? 15),
                    em_nivel_riesgo: this.obtenerNumeroCelda(ws, r, cols.nr ?? 16),
                    em_interpretacion_nr: this.obtenerTextoCelda(ws, r, cols.interpretacionNR ?? 17),
                    em_aceptabilidad: this.normalizarAceptabilidad(this.obtenerTextoCelda(ws, r, cols.aceptabilidad ?? 18)),
                    em_num_expuestos: this.obtenerTextoCelda(ws, r, cols.numeroExpuestos ?? 19),
                    em_peor_consecuencia: this.obtenerTextoCelda(ws, r, cols.peorConsecuencia ?? 20),
                    em_eliminacion: [this.obtenerTextoCelda(ws, r, cols.eliminacion ?? 21)],
                    em_sustitucion: [this.obtenerTextoCelda(ws, r, cols.sustitucion ?? 22)],
                    em_controles_ing: [this.obtenerTextoCelda(ws, r, cols.controlesIngenieria ?? 23)],
                    em_controles: [this.obtenerTextoCelda(ws, r, cols.controlesAdministrativos ?? 24)],
                    em_equipos: this.obtenerTextoCelda(ws, r, cols.epp ?? 25),
                    em_fecha_editado: "",
                    em_fecha_registro: "",
                    em_antecedente: "Ninguno",
                    em_requisito_legal: true,
                });
            }
            this.registros = out;
        },

        obtenerClasificacionPeligro(peligro) {
            const registro = this.peligros.clasificacion.find(p => p.nombre.toLowerCase().includes(peligro.toLowerCase()));
            return registro ? registro : null;
        },

        obtenerSubClasificacionPeligro(subclasificacion, idPeligro) {
            const registro = this.peligros.subclasificacion.find(p => p.nombre.toLowerCase().includes(subclasificacion.toLowerCase()) && p.idPeligro === idPeligro);
            return registro ? registro : null;
        },

        convertirTextoCapital(text) {
            const s = (text == null ? "" : String(text)).trim();
            if (!s) return "";

            return s
                .toLowerCase()
                .replace(/\s+/g, " ")
                .split(" ")
                .map(w => (w ? w[0].toUpperCase() + w.slice(1) : ""))
                .join(" ");
        },

        obtenerTextoCelda(ws, r, c, mergeIndex) {
            const addr = XLSX.utils.encode_cell({ r, c });
            const cell = ws[addr];
            if (cell) {
                const raw = cell.w ?? cell.v;
                const v = raw == null ? "" : String(raw).trim();
                if (v) return v;
            }

            const m = mergeIndex?.cellToMerge?.[`${r},${c}`];
            if (m) {
                const tlAddr = XLSX.utils.encode_cell({ r: m.s.r, c: m.s.c });
                const tlCell = ws[tlAddr];
                const raw = tlCell?.w ?? tlCell?.v;
                return raw == null ? "" : String(raw).trim();
            }

            return "";
        },

        obtenerNumeroCelda(ws, r, c) {
            const s = this.obtenerTextoCelda(ws, r, c);
            if (!s) return null;
            const n = Number(String(s).replace(",", "."));
            return Number.isFinite(n) ? n : null;
        },

        rellenarCelda(ws, r, c, minRow) {
            for (let rr = r; rr >= minRow; rr--) {
                const v = this.obtenerTextoCelda(ws, rr, c);
                if (v) return v;
            }
            return "";
        },

        obtenerCabeceraFilaPorCeldas(ws, range) {
            const needA = this.normalizar("PROCESO");
            const needB = this.normalizar("ZONA/LUGAR");
            const maxScanRows = Math.min(range.e.r, range.s.r + 60);
            const maxScanCols = Math.min(range.e.c, range.s.c + 30);
            for (let r = range.s.r; r <= maxScanRows; r++) {
                let hasProceso = false;
                let hasZona = false;
                for (let c = range.s.c; c <= maxScanCols; c++) {
                    const v = this.normalizar(this.obtenerTextoCelda(ws, r, c));
                    if (v === needA) hasProceso = true;
                    if (v === needB || (v.includes("ZONA") && v.includes("LUGAR"))) hasZona = true;
                }
                if (hasProceso && hasZona) return r;
            }
            return 5;
        },

        detectarColumnaPorEncabezado(ws, headerRow, endCol) {
            const headerRow2 = headerRow + 1;
            const H = [];
            for (let c = 0; c <= endCol; c++) {
                const h2 = this.obtenerTextoCelda(ws, headerRow2, c);
                const h1 = this.obtenerTextoCelda(ws, headerRow, c);
                H[c] = this.normalizar(h2 || h1);
            }

            const obtenerPorClave = (tokens) => {
                const t = tokens.map(this.normalizar);
                for (let c = 0; c < H.length; c++) {
                    const h = H[c] || "";
                    if (t.every(tok => h.includes(tok))) return c;
                }
                return null;
            };

            return {
                proceso: obtenerPorClave(["PROCESO"]) ?? 0,
                zonaLugar: obtenerPorClave(["ZONA", "LUGAR"]) ?? 1,
                actividades: obtenerPorClave(["ACTIVIDADES"]) ?? 2,
                tareas: obtenerPorClave(["TAREAS"]) ?? 3,
                tareaRutinaria: obtenerPorClave(["RUTINARIA"]) ?? 4,

                peligroDescripcion: obtenerPorClave(["DESCRIPCIÓN"]) ?? 5,
                peligroClasificacion: obtenerPorClave(["CLASIFICACIÓN"]) ?? 6,
                efectosPosibles: obtenerPorClave(["EFECTOS"]) ?? 7,

                controlesFuente: obtenerPorClave(["FUENTE"]) ?? 8,
                controlesMedio: obtenerPorClave(["MEDIO"]) ?? 9,
                controlesIndividuo: obtenerPorClave(["INDIVIDUO"]) ?? 10,

                nd: obtenerPorClave(["DEFICIENCIA", "ND"]) ?? 11,
                ne: obtenerPorClave(["EXPOSICIÓN", "NE"]) ?? 12,
                np: obtenerPorClave(["PROBALIDAD", "NP"]) ?? 13,
                interpretacionNP: obtenerPorClave(["INTERPRETACIÓN", "NP"]) ?? 14,
                nc: obtenerPorClave(["CONSECUENCIA", "NC"]) ?? 15,
                nr: obtenerPorClave(["INTERVENCIÓN", "NR"]) ?? 16,
                interpretacionNR: obtenerPorClave(["INTERPRETACIÓN", "RIESGO", "NR"]) ?? 17,

                aceptabilidad: obtenerPorClave(["ACEPTABILIDAD"]) ?? 18,
                numeroExpuestos: obtenerPorClave(["EXPUESTOS"]) ?? 19,
                peorConsecuencia: obtenerPorClave(["PEOR", "CONSECUENCIA"]) ?? 20,

                eliminacion: obtenerPorClave(["ELIMINACIÓN"]) ?? 21,
                sustitucion: obtenerPorClave(["SUSTITUCIÓN"]) ?? 22,
                controlesIngenieria: obtenerPorClave(["INGENIERIA"]) ?? 23,
                controlesAdministrativos: obtenerPorClave(["ADMINISTRATIVOS"]) ?? 24,
                epp: obtenerPorClave(["EPP"]) ?? 25,
            };
        },

        normalizar(v) {
            return (v == null ? "" : String(v))
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, " ")
                .replace(/[.,;:()]/g, "")
                .trim()
                .toUpperCase();
        },

        extraerPeligro(text) {
            const s = (text == null ? "" : String(text)).trim();
            if (!s) return "";

            const normalized = s.replace(/（/g, "(").replace(/）/g, ")");

            return normalized.split("(")[0].trim();
        },

        extraerSubClasificacionPeligro(text) {
            const s = (text == null ? "" : String(text)).trim();
            if (!s) return "";

            const normalized = s.replace(/（/g, "(").replace(/）/g, ")");
            const matches = [...normalized.matchAll(/\(([^()]*)\)/g)];

            if (!matches.length) return "";

            return (matches[matches.length - 1][1] || "").trim();
        },

        normalizarInterpretacionNP(value) {
            const raw = (value == null ? "" : String(value)).trim();
            if (!raw) return "";

            const n = raw
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, " ")
                .replace(/[.,;:()]/g, "")
                .trim()
                .toUpperCase();

            if (n.includes("MUY") && n.includes("ALTO")) return "Muy Alto";
            if (n.includes("ALTO")) return "Alto";
            if (n.includes("MEDIO")) return "Medio";
            if (n.includes("BAJO")) return "Bajo";

            return raw;
        },

        normalizarAceptabilidad(value) {
            const raw = (value == null ? "" : String(value)).trim();
            if (!raw) return "";

            const n = raw
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, " ")
                .replace(/[.,;:()]/g, "")
                .trim()
                .toUpperCase();

            if ((n.includes("NO") && n.includes("ACEPTABLE")) || n.includes("INACEPTABLE")) {
                return "No Aceptable";
            }

            if (
                n.includes("ACEPTABLE") &&
                (n.includes("CONTROL") || n.includes("C/ CONTROL") || n.includes("C CONTROL"))
            ) {
                return "Aceptable con Control Específico";
            }

            if (n.includes("MEJORABLE")) {
                return "Mejorable";
            }

            if (n.includes("ACEPTABLE")) {
                return "Aceptable";
            }

            return raw;
        },

        normalizarTareaRutinaria(value) {
            const raw = (value == null ? "" : String(value)).trim();
            if (!raw) return "";

            const n = raw
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, " ")
                .replace(/[.,;:()]/g, "")
                .trim()
                .toUpperCase();

            if (["SI", "S", "X", "1", "TRUE", "VERDADERO", "YES"].includes(n)) return "Si";
            if (n.includes("SI")) return "Si";

            if (["NO", "N", "0", "FALSE", "FALSO"].includes(n)) return "No";
            if (n.includes("NO")) return "No";

            return "";
        },

        async alternarCentroTrabajo() {
            if (!this.fechaCambio) {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "¡Fecha matriz vacía!",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "Entendido",
                });
            } else if (this.id && !this.controlCambioMatriz.controlCambios.observacionCambio) {
                Swal.fire({
                    icon: "warning",
                    title: "Observación vacía en Fecha Matriz",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "Entendido",
                });
            } else if (!this.cliente.nombre) {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "¡Cliente vacío!",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "Entendido",
                });
            } else {
                if (this.id) {
                    await this.actualizarCentroTrabajo();
                } else {
                    await this.agregarCentroTrabajo();
                }
            }
        },

        async agregarCentroTrabajo() {
            Swal.fire({
                icon: "warning",
                title: `<h5>Se importarán ${this.registros.length} registros para el centro de trabajo ${this.cliente.centroTrabajo}</h5>`,
                html: "<p>¿Ya esta todo listo? Deseas confirmar la importación</p>",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Confirmar",
                cancelButtonText: "Continuar Editando",
                reverseButtons: true,
                customClass: {
                    confirmButton: "btn btn-success btn-md fw-bold ml-2 mb-3",
                    cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(async (result) => {
                if (result.value) {
                    this.$isLoading(true);
                    this.fechaCambio = this.fechaCambio.split("-");
                    const nuevaFecha = new Date(
                        this.fechaCambio[0],
                        this.fechaCambio[1] - 1,
                        this.fechaCambio[2]
                    );
                    this.controlCambioMatriz.controlCambios.fechaCambio = nuevaFecha;
                    const clienteEmpresaRef = db.collection("cliente_empresa").doc();
                    const idCliente = clienteEmpresaRef.id;
                    await db.collection("cliente_empresa").doc(idCliente).set({
                        em_baja: true,
                        em_activo: true,
                        em_cargo: this.cliente.contacto.cargo,
                        em_ciudad: this.cliente.ubicacion.municipio,
                        em_completo: true,
                        em_correo_contacto: this.cliente.contacto.correo,
                        em_departamento: this.cliente.ubicacion.departamento,
                        em_direccion: this.cliente.ubicacion.direccion,
                        em_empresa: "G4S",
                        em_fecha: firebase.firestore.FieldValue.serverTimestamp(),
                        em_fecha_editado: nuevaFecha,
                        em_gps: this.cliente.ubicacion.coordenadas,
                        em_id_cliente_principal: this.cliente.id,
                        em_nit: "",
                        em_num_trabajadores: this.cliente.numeroExpuestos,
                        em_numero_contacto: this.cliente.contacto.telefono,
                        em_pais: this.cliente.ubicacion.pais,
                        em_regional: this.cliente.ubicacion.regional,
                        em_registrado_por: this.$store.state.email_session,
                        em_responsable: this.cliente.contacto.nombre,
                        em_sector: this.cliente.sector,
                        em_trabajo: this.cliente.centroTrabajo,
                        em_visita: this.$store.state.email_session,
                    });
                    this.$store.state.n_max_expuestos = this.cliente.numeroExpuestos;
                    this.$store.state.msp_c_key = idCliente;
                    this.$store.state.msp_c_key_cliente_iper = this.cliente.id;
                    await this.importarMatriz();
                    await this.registrarControlCambio(idCliente);
                    this.$isLoading(false);
                    await Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "¡Matriz importada!",
                        text: "La matriz ha sido importada correctamente",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "Entendido",
                    }).then((result) => {
                        if (result.value) {
                            this.limpiarVariables();
                        }
                    });
                }
            });
        },

        async actualizarCentroTrabajo() {
            Swal.fire({
                icon: "warning",
                title: `<h5>Se <u class='text-danger font-weight-bold'>eliminarán ${this.matriz.filter(item => item.coleccion === 'matriz_riesgo').length} registros antiguos</u> y se <u class='font-weight-bold'>cargarán ${this.registros.length} nuevos registros</u> para el centro de trabajo ${this.cliente.centroTrabajo}</h5>`,
                html: "<p>¿Ya esta todo listo? Deseas confirmar la <u class='text-danger font-weight-bold'>eliminación de los registros antiguos</u> y la <u class='font-weight-bold'>importación de los nuevos registros</u>",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Confirmar",
                cancelButtonText: "Continuar Editando",
                reverseButtons: true,
                customClass: {
                    confirmButton: "btn btn-success btn-md fw-bold ml-2 mb-3",
                    cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(async (result) => {
                if (result.value) {
                    Swal.fire({
                        icon: "warning",
                        title: "<h5>¿Estás seguro de continuar con esta acción? Recuerda que esta acción es irreversible</h5>",
                        html: `<u class='text-danger font-weight-bold'>No se podrá recuperar la información indicada anteriormente.</u>`,
                        buttonsStyling: false,
                        showCancelButton: true,
                        confirmButtonText: "Si, estoy seguro",
                        cancelButtonText: "Cancelar",
                        reverseButtons: true,
                        customClass: {
                            confirmButton: "btn btn-danger btn-md fw-bold ml-2 mb-3",
                            cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async (result) => {
                        if (result.value) {
                            this.$isLoading(true);
                            this.fechaCambio = this.fechaCambio.split("-");
                            const nuevaFecha = new Date(
                                this.fechaCambio[0],
                                this.fechaCambio[1] - 1,
                                this.fechaCambio[2]
                            );
                            this.controlCambioMatriz.controlCambios.fechaCambio = nuevaFecha;
                            await db.collection("cliente_empresa").doc(this.id).update({
                                em_id_cliente_principal: this.cliente.id,
                                em_cargo: this.cliente.contacto.cargo,
                                em_ciudad: this.cliente.ubicacion.municipio,
                                em_correo_contacto: this.cliente.contacto.correo,
                                em_departamento: this.cliente.ubicacion.departamento,
                                em_direccion: this.cliente.ubicacion.direccion,
                                em_fecha_editado: nuevaFecha,
                                em_gps: this.cliente.ubicacion.coordenadas,
                                em_num_trabajadores: this.cliente.numeroExpuestos,
                                em_numero_contacto: this.cliente.contacto.telefono,
                                em_pais: this.cliente.ubicacion.pais,
                                em_regional: this.cliente.ubicacion.regional,
                                em_responsable: this.cliente.contacto.nombre,
                                em_sector: this.cliente.sector,
                                em_trabajo: this.cliente.centroTrabajo,
                            });
                            this.$store.state.n_max_expuestos = this.cliente.numeroExpuestos;
                            this.$store.state.msp_c_key = this.id;
                            this.$store.state.msp_c_key_cliente_iper = this.cliente.id;
                            if (this.matriz.length > 0) {
                                await this.eliminarMatriz();
                            }
                            await this.importarMatriz();
                            await this.registrarControlCambio(this.id);
                            this.$isLoading(false);
                            await Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "¡Matriz editada!",
                                text: "La matriz ha sido editada correctamente",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                confirmButtonText: "Entendido",
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.replace("/lista_clientes");
                                }
                            });
                        }
                    });
                }
            });
        },

        async eliminarMatriz() {
            await Promise.all(
                this.matriz.map(async (item) => {
                    return await this.eliminarRegistro(item);
                })
            );
        },

        async eliminarRegistro(item) {
            await db.collection(item.coleccion).doc(item.id).delete();
            return {
                ...item
            }
        },

        limpiarVariables() {
            this.$store.state.n_max_expuestos = "";
            this.$store.state.msp_c_key = "";
            this.$store.state.msp_c_key_cliente_iper = "";
            this.cliente = {
                id: "",
                nombre: "",
                sector: "",
                centroTrabajo: "",
                numeroExpuestos: "",
                ubicacion: {
                    regional: "",
                    pais: "Colombia",
                    departamento: "",
                    municipio: "",
                    direccion: "",
                    coordenadas: "",
                },
                contacto: {
                    nombre: "Ángela Johana Gaitán López",
                    cargo: "Gerente H&S",
                    correo: "angela.gaitan@co.g4s.com",
                    telefono: 3212543320
                }
            };
            this.controlCambioMatriz = {
                controlCambios: {
                    idControlCambio: "",
                    tipoCambio: this.$route.params.id ? "Actualización" : "Elaboración",
                    fechaCambio: "",
                    observacionCambio: "",
                    correoUsuario: this.$store.state.email_session,
                },
                registro: {
                    creacion: firebase.firestore.FieldValue.serverTimestamp(),
                },
            };
            this.fechaCambio = "";
            this.registros = [];
            document.getElementById('seleccionador').value = "";
        },

        async importarMatriz() {
            if (this.$store.state.msp_c_key && this.$store.state.msp_c_key_cliente_iper) {
                const copiaMatriz = JSON.parse(JSON.stringify(this.registros));
                await Promise.all(
                    copiaMatriz.map(async (item) => {
                        return await this.registrarProceso(item);
                    })
                );
                await Promise.all(
                    copiaMatriz.map(async (item) => {
                        return await this.registrarPeligro(item);
                    })
                );
            }
        },

        async registrarProceso(item) {
            await db.collection("proceso").doc(item.em_id_proceso).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_proceso_riesgo: item.em_proceso,
            });
            await db.collection("zona").doc(item.em_id_zona).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_proceso: item.em_id_proceso,
                em_zona: item.em_zona,
            });
            await db.collection("actividades").doc(item.em_id_acti).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_proceso: item.em_id_proceso,
                em_id_zona: item.em_id_zona,
                em_actividades: item.em_actividad,
            });
            await db.collection("tareas").doc(item.em_id_tareas).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_proceso: item.em_id_proceso,
                em_id_zona: item.em_id_zona,
                em_id_acti: item.em_id_acti,
                em_tareas: item.em_tarea,
            });

            return {
                ...item
            }
        },

        async registrarPeligro(item) {
            const matrizRef = db.collection("matriz_riesgo").doc();
            const idMatriz = matrizRef.id;
            item.em_id_cliente = this.$store.state.msp_c_key;
            item.em_id_cliente_iper = this.$store.state.msp_c_key_cliente_iper;
            item.em_fecha_registro = firebase.firestore.FieldValue.serverTimestamp();
            item.em_fecha_editado = firebase.firestore.FieldValue.serverTimestamp();
            await db.collection("matriz_riesgo").doc(idMatriz).set(item);
        },

        async registrarControlCambio(id) {
            const q = "cliente_empresa/" + id + "/controlcambios";
            const refControlCambios = db.collection(q).doc();
            this.controlCambioMatriz.controlCambios.idControlCambio = refControlCambios.id;
            await db.collection(q).doc(this.controlCambioMatriz.controlCambios.idControlCambio).set(this.controlCambioMatriz);
        }
    }
}
</script>

<style>
.vgt-table {
    border-collapse: separate !important;
    border-spacing: 0;
    border-top: 0 !important;
    border: none !important;
}

.vgt-table thead {
    position: sticky;
    top: 0;
    z-index: 1;
}

.vgt-table th,
.vgt-table td {
    border-width: 0.5px !important;
}

.vgt-table thead th.sorting-desc button:before {
    border-top: 5px solid #e8640c;
}

.vgt-table thead th.sorting-asc button:after {
    border-bottom: 5px solid #e8640c;
}

.vgt-table td {
    font-size: 11pt !important;
    background: #ececec !important;
}

.vgt-table th {
    font-size: 11pt !important;
    text-align: left;
    color: white !important;
}

.vgt-table th.vgt-checkbox-col {
    color: #2f2f2f !important;
    border-bottom: 1px solid #dcdfe6;
    background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-table th.filter-th {
    color: #2f2f2f !important;
    border-bottom: 1px solid #dcdfe6;
    background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-global-search {
    background: linear-gradient(rgb(230, 231, 232), rgb(230, 231, 232));
}

.vgt-table th.vgt-checkbox-col input[type="checkbox"] {
    background-color: transparent;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 1.1em;
    height: 1.1em;
    border: 0.15em solid currentColor;
    border-radius: 0.15em;
    transform: translateY(-0.075em);
    accent-color: #e8640c;
}

.vgt-wrap__footer {
    background: rgb(230, 231, 232);
    border: none;
}

.footer__row-count__label {
    font-size: 12pt !important;
}

.vgt-table thead th {
    color: #2f2f2f !important;
    border-bottom: 1px solid #dcdfe6;
    background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-wrap__footer .footer__row-count__select {
    font-size: 11pt !important;
    padding: 0;
    margin-top: -6px;
    margin-left: 5px;
}

.vgt-wrap__footer .footer__navigation__page-btn span {
    font-size: 11pt;
}

.vgt-wrap__footer .footer__navigation>button:first-of-type {
    margin-right: 0px;
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.right::after {
    border-left: 6px solid #e8640c;
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.left::after {
    border-right: 6px solid #e8640c;
}

.footer__navigation__page-info {
    margin: 0 2px !important;
}

.vgt-wrap__footer .footer__row-count::after {
    content: "";
    display: block;
    position: absolute;
    height: 0;
    width: 0;
    right: 6px;
    top: 50%;
    margin-top: -1px;
    border-top: 0px solid #606266;
    border-left: 0px solid transparent;
    border-right: 0px solid transparent;
    border-bottom: none;
    pointer-events: none;
}

input.vgt-input,
select.vgt-select,
input.vgt-input:focus {
    outline: none !important;
    border: 1px solid #e8640c !important;
}

@media only screen and (max-width: 570px) {
    .vgt-wrap__footer .footer__navigation__page-btn {
        margin-left: -15px !important;
        margin-right: 15px !important;
    }

    .vgt-wrap__footer .footer__row-count__select {
        margin-right: auto;
    }

    .footer__navigation__page-info {
        width: 100%;
        margin: 10px 75px 15px 0px !important;
    }

    .vgt-pull-right {
        float: left !important;
    }

    .vgt-wrap__footer .footer__navigation__page-btn span {
        font-size: 9pt;
    }
}

.footer__navigation__page-info {
    font-size: 11pt !important;
}

.bg_blue {
    background: #99CCFF !important;
}

.bg_gray {
    background: #C0C0C0 !important;
}

.bg_blue_light {
    background: #CCFFFF !important;
}

.bg_orange {
    background: #FFCC99 !important;
}

.bg_purple {
    background: #CCCCFF !important;
}

.bg_yellow {
    background: #FFFF99 !important;
}

.bg_success {
    background: #92d050 !important;
}

.bg_warning {
    background: #ffff00 !important;
}

.bg_danger {
    background: #ff0000 !important;
}
</style>

<style scoped>
.border-orange {
    border: 2px solid #ee8813;
}
</style>